import { render, staticRenderFns } from "./QuickPanel.vue?vue&type=template&id=0560829c&"
import script from "./QuickPanel.vue?vue&type=script&lang=js&"
export * from "./QuickPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports